import { Controller } from "@hotwired/stimulus";
import collapsibleContainer from "@app/components/common/collapsibleContainer";

const MOBILE_WIDTH = 768;

export default class extends Controller {
  static collapsibleInitialized = false;
  static targets = ["collapseButton"];

  connect() {
    if (!this.constructor.collapsibleInitialized) {
      collapsibleContainer();
      this.constructor.collapsibleInitialized = true;
      this.handleHashNavigation();
    }

    this.closeOnMobile();
  }

  handleHashNavigation() {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      this.scrollToElement(hash);
    }
  }

  scrollToElement(hash) {
    const targetElement = document.getElementById(hash);
    if (targetElement) {
      const collapseButton = targetElement.querySelector(".hs-collapse-toggle");
      collapseButton?.click();
      setTimeout(() => targetElement.scrollIntoView({ behavior: "smooth", block: "end" }), 300);
    }
  }

  closeOnMobile() {
    if (window.innerWidth >= MOBILE_WIDTH || this.element.dataset.closeMobile !== "true") return;

    if (this.collapseButtonTarget.getAttribute("aria-expanded") === "true") {
      this.collapseButtonTarget.click();
    }
  }
}
